import { getServiceAlreadyBoundErrorMsg } from '../errorMessages';
import { callMethod, convertResultToResponse } from './utils';
var serviceBindings = new Map();

var getBindingKey = function getBindingKey(_ref) {
  var domain = _ref.domain,
      serviceName = _ref.serviceName;
  return "".concat(domain, ":").concat(serviceName);
};

export function getServiceBinding(path) {
  var key = getBindingKey(path);
  return serviceBindings.get(key);
}

function createMethodBinding(_ref2) {
  var implementation = _ref2.implementation,
      domain = _ref2.domain,
      serviceName = _ref2.serviceName,
      method = _ref2.method;
  return function (_ref3) {
    var payload = _ref3.payload;
    var implementationMethod = implementation[method.property].bind(implementation);
    return callMethod(implementationMethod, payload).then(convertResultToResponse(method, domain, serviceName)).catch(function (error) {
      var result = convertResultToResponse(method, domain, serviceName)(error);
      return Promise.reject(result);
    });
  };
}

function createServiceMethodsBinding(args) {
  var implementation = args.implementation,
      domain = args.domain,
      serviceName = args.serviceName,
      methods = args.methods;
  var methodBindings = methods.map(function (method) {
    return [method.name, createMethodBinding({
      implementation: implementation,
      domain: domain,
      serviceName: serviceName,
      method: method
    })];
  });
  return new Map(methodBindings);
}

export function bindService(args) {
  var implementation = args.implementation,
      domain = args.domain,
      serviceName = args.serviceName;
  var key = getBindingKey({
    domain: domain,
    serviceName: serviceName
  });

  if (serviceBindings.has(key)) {
    throw new Error(getServiceAlreadyBoundErrorMsg(serviceName));
  }

  serviceBindings.set(key, {
    implementation: implementation,
    methods: createServiceMethodsBinding(args)
  });
}
export function unbindService(path) {
  var key = getBindingKey(path);
  serviceBindings.delete(key);
}
//# sourceMappingURL=serviceBindings.js.map